/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Complete/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Booking from './Booking/index'
import Gotoform01 from 'DesignSystem/Svgs/Gotoform01/index'
import GreyfinchBird from 'DesignSystem/Svgs/GreyfinchBird/index'
import MedicalForm from './MedicalForm/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Complete({
  children,
  viewPath = "/App/Widget/Content/Questions/Complete",
  subtitle
  
}) {
  let isBefore = useIsBefore()
let authAccessTokenDataLeadIdValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.lead_id',
})
let widgetSettingsMedicalformenabledValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'settings.medicalFormEnabled',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtTypographyFontsizeS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.s'
        })
let dtTypographyFontweightRegular = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.regular'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let widgetHasBookingValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'hasBooking',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  subtitle
  
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Complete.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-ZCC95x': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="auth.access_token_data.lead_id"
 text={authAccessTokenDataLeadIdValueData}
 color="white"
 fontSize={1}
 className="patientUuid"
 className="patientUuid"
/>
<fromFlow.When is={!widgetSettingsMedicalformenabledValueData}>
<Gotoform01
  viewPath={`${viewPath}/Gotoform01`}
 data="widget.settings.medicalFormEnabled"
 height={240}
 marginTop={dtSpaceS}
 width={340}
/>
</fromFlow.When>
<div
  data-testid="Complete.Horizontal"
  data-view-path={viewPath}
 style={{'--bblr-2-ZCC95x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-ZCC95x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-ZCC95x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-ZCC95x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-6-ZCC95x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-7-ZCC95x': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 marginTop={20}
 fontSize={dtTypographyFontsizeS}
 fontWeight={dtTypographyFontweightRegular}
 text={subtitle}
 hyphens="none"
/>
</div>
<div
  data-testid="Complete.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Booking
  viewPath={`${viewPath}/Booking`}
/>
<MedicalForm
  viewPath={`${viewPath}/MedicalForm`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 size="large"
 marginTop={dtSpaceM}
 text="If you have any problems please contact the practice directly."
 hyphens="none"
/>
<fromFlow.When is={widgetHasBookingValueData}>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 data="widget.hasBooking"
 marginTop={dtSpaceL}
 color="#0093c9"
 text="Start over"
 onClick={onClick}
/>
</fromFlow.When>
</div>
<div
  data-testid="Complete.Logo"
  data-view-path={viewPath}
 style={{'--pl-8-ZCC95x': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-9-ZCC95x': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-ZCC95x': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Logo}`}
>
<GreyfinchBird
  viewPath={`${viewPath}/GreyfinchBird`}
 height={42}
 width={42}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color="#858585"
 fontSize={dtTypographyFontsizeS}
 fontWeight={300}
 text="Powered By Greyfinch"
/>
</div>
</div>
{children}
</React.Fragment>)
}